var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0L0 9h3v8h5v-6h4v6h5V9h3z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_home-e601a0a8.svg";
export { SvgIcnHome as ReactComponent };